import { del, get, post, put } from '../client';

export const staffApi = {
  list: (params) => get('/staff', { params }),
  getById: (id) => get(`/staff/${id}`),
  create: (body) => post('/staff', body),
  update: (id, body) => put(`/staff/${id}`, body),
  assignRoles: (id, roleIds) => put(`/staff/${id}/roles`, { roleIds }),
  changePassword: (id, body) => post(`/staff/${id}/change-password`, body),
  remove: (id) => del(`/staff/${id}`),
};
